import { readCookie } from "./Cookies";

const getUserMailAndCrmIdFromCookies = () => {
    return {mail: readCookie('usuarioemail'), crmId: readCookie('Crm_id')}
}

export default getUserMailAndCrmIdFromCookies;